import { Controller } from '@hotwired/stimulus'

// A non-Turbo form (finance e-mail) submits once: further submits while the page unloads are dropped, so a double
// click cannot send twice. Buttons are not disabled (that would drop the clicked button's name from the form data).
// The server refuses a duplicate send as well (FinanceEmails::Send::AlreadySent).
export default class SubmitOnceController extends Controller<HTMLFormElement> {
  private submitted = false

  private readonly reset = (): void => {
    this.submitted = false // a page restored from the back/forward cache can submit again
    this.element.removeAttribute('aria-busy')
  }

  override connect(): void {
    window.addEventListener('pageshow', this.reset)
  }

  override disconnect(): void {
    window.removeEventListener('pageshow', this.reset)
  }

  guard(event: SubmitEvent): void {
    if (event.defaultPrevented) return // held back by email-compose#submit until its preview lands, then submitted again
    if (this.submitted) {
      event.preventDefault()
      return
    }
    this.submitted = true
    this.element.setAttribute('aria-busy', 'true')
  }
}
